import { render } from "./ServicePayFail.vue?vue&type=template&id=99a1a038"
import script from "./ServicePayFail.vue?vue&type=script&lang=js"
export * from "./ServicePayFail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__